import { render, staticRenderFns } from "./DataTablePagination.vue?vue&type=template&id=2d3db71a&scoped=true&"
import script from "./DataTablePagination.vue?vue&type=script&lang=js&"
export * from "./DataTablePagination.vue?vue&type=script&lang=js&"
import style0 from "./DataTablePagination.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DataTablePagination.vue?vue&type=style&index=1&id=2d3db71a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3db71a",
  null
  
)

export default component.exports